import React from "react";

import { Check as CheckIcon, Clear as ClearIcon } from "@material-ui/icons";
import {
  makeStyles,
  createStyles,
  Theme,
  IconButton,
  InputAdornment,
  FormControl,
  OutlinedInput,
  InputLabel,
} from "@material-ui/core";
import clsx from "clsx";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      display: "inline",
      width: 200,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(1.0),
    },
    inputRoot: {
      backgroundColor: theme.palette.background.paper,
    },
    inputMarginDense: {
      padding: "4px 8px",
    },
    icon: {
      position: "relative",
      top: -8,
      fontSize: "1rem",
    },
    iconButtonCancel: {
      marginRight: theme.spacing(0.2),
      width: "0.9rem",
      height: "0.9rem",
    },
    iconButtonAdd: {
      width: "0.9rem",
      height: "0.9rem",
    },
  })
);

interface Props {
  text: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCancel: () => void;
  onAdd: () => void;
  inputRef: React.Ref<HTMLInputElement>;
}

/** 同義語追加テキストフィールド */
export function SynonymAddTextField(props: Props) {
  const classes = useStyles();

  const { text, onChange, onAdd, onCancel, inputRef } = props;

  return (
    <FormControl className={clsx(classes.formControl)} variant="outlined">
      <InputLabel htmlFor="input-add-synonym" />
      <OutlinedInput
        id="input-add-synonym"
        type="text"
        classes={{
          root: classes.inputRoot,
          inputMarginDense: classes.inputMarginDense,
        }}
        margin="dense"
        value={text}
        onChange={onChange}
        endAdornment={(
          <InputAdornment position="end">
            {/*
              キャンセル

            */}
            <IconButton
              className={classes.iconButtonCancel}
              aria-label="cancel add new synonym"
              onClick={onCancel}
              edge="end"
            >
              <ClearIcon fontSize="small" className={classes.icon} />
            </IconButton>
            {/*
              確定

            */}
            <IconButton
              className={classes.iconButtonAdd}
              aria-label="submit add new synonym"
              onClick={onAdd}
              edge="end"
            >
              <CheckIcon fontSize="small" className={classes.icon} />
            </IconButton>
          </InputAdornment>
        )}
        inputRef={inputRef}
      />
    </FormControl>
  );
}
